import { render } from "./skill-input.vue?vue&type=template&id=1010cf87&ts=true"
import script from "./skill-input.vue?vue&type=script&lang=ts"
export * from "./skill-input.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__